export default "__VITE_ASSET__6ymZUS9h__"